import React from 'react';
import type { Claim } from '../../api/claims/interface';
import type { Run } from '../../api/runs/interface';
import type { SearchType } from '../../api/search/interface';
import searchSlice from '../../data/search/logic';
import type { StoreState } from '../../data/store';
import type { RouteParams } from '../../helpers/route-types';
import type { EscRouteDefs } from '../Routing/Routing';
import type { AskOwlHookState } from './AskOwlComponent/useAskOwlHook';
import type {
  ActivitiesHookHandler,
  ActivitiesHookState,
} from './ClaimActivitiesContainer/useClaimActivitiesHook';

export type Params = RouteParams<EscRouteDefs.Dossier>;

export const TAB_KEYS = {
  summaries: 'summaries',
  templates: 'templates',
  insights: 'insights',
  files: 'files',
  notes: 'notes',
  askOwl: 'askOwl',
} as const;

export const PROCESSING_STATUSES: Set<string> = new Set([
  'rt_ready',
  'rt_processing',
  'ready',
  'preprocessing',
  'preprocessed',
  'processing',
  'dev-owl_rt_ready',
  'dev-owl_rt_processing',
  'dev-owl_ready',
  'dev-owl_preprocessing',
  'dev-owl_preprocessed',
  'dev-owl_processing',
  'stg-owl_rt_ready',
  'stg-owl_rt_processing',
  'stg-owl_ready',
  'stg-owl_preprocessing',
  'stg-owl_preprocessed',
  'stg-owl_processing',
]);

export const ClaimDetailsContext = React.createContext<{
  claimMetadata?: Claim;
  activities: {
    currentActivities: ActivitiesHookState['activities'];
    activitiesHookHandler: ActivitiesHookHandler;
    actions?: StoreState['activities']['actions'];
  };
  askOwl: {
    answer?: AskOwlHookState['answer'];
    actions: AskOwlHookState['actions'];
    askOwlHookHandler: {
      search(data: {
        query: string;
        run?: Run;
        searchType?: SearchType;
        threadId: string | null;
        conversational?: boolean;
      }): void;
    };
  };
  templates: {
    selectedTemplate: {
      templateId: string;
      templateType: string;
      isEditable: boolean;
    } | null;
    setSelectedTemplate: (
      template: {
        templateId: string;
        templateType: string;
        isEditable: boolean;
      } | null
    ) => void;
  };
}>({
  askOwl: {
    actions: searchSlice.initialState.actions,
    askOwlHookHandler: {
      search: () => {
        throw new Error('askOwl.askOwlHookHandler.search() not hooked up!');
      },
    },
  },
  activities: {
    currentActivities: [],
    activitiesHookHandler: {
      fetchActivities: () => {
        throw new Error('activites.fetchActivities() not hooked up!');
      },
    },
  },
  templates: {
    selectedTemplate: null,
    setSelectedTemplate: () => {
      throw new Error('templates.setSelectedTemplate() not hooked up!');
    },
  },
});
